import { Md5 } from 'ts-md5'

import { TENANT } from '../tenant'

export const userDataGetAsuid = ({
  customerNumber,
  tenant,
}: {
  customerNumber: string
  tenant: TENANT
}): string => {
  /**
   * Non-COM tenants require the shop and tenant prefix in the hashed value.
   * https://jira.shop-apotheke.com/browse/RMADT-4032
   */
  const valueToHash =
    tenant === TENANT.COM ? customerNumber : `shop${tenant}${customerNumber}`

  return Md5.hashStr(valueToHash)
}
